module.exports = __webpack_public_path__ + "img/b_KalsiyForte_right.ea7ccc6e.jpeg";